// extracted by mini-css-extract-plugin
export default {"Title":"iStyles_Title__MIOHh","SubTitle":"iStyles_SubTitle__rBLI2"};